export default __webpack_public_path__ + "static/media/7.2f78f438.png";